import React from "react";
import { Box, Collapse, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface FormErrorBoxProps {
  errors: string[];
}

const FormErrorBox: React.FC<FormErrorBoxProps> = ({ errors }) => {
  const { t } = useTranslation();
  const visibleErrors = Array.from(new Set(errors.filter(Boolean)));

  return (
    <Collapse in={visibleErrors.length > 0} animateOpacity>
      <Box
        borderWidth="1px"
        borderColor="red.200"
        bg="red.50"
        borderRadius="md"
        p={3}
        w="full"
      >
        <Text color="red.700" fontWeight="semibold" mb={2}>
          {t("common.formErrorTitle")}
        </Text>
        <UnorderedList ml={5} spacing={1}>
          {visibleErrors.map((message, index) => (
            <ListItem key={`${message}-${index}`} color="red.700" fontSize="sm">
              {message}
            </ListItem>
          ))}
        </UnorderedList>
      </Box>
    </Collapse>
  );
};

export default FormErrorBox;
